module.exports = __webpack_public_path__ + "assets-cabinet/img/un-hidden.79eec0c2.svg";